package ca.northroot.app.ui.customers

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ca.northroot.app.data.*
import ca.northroot.app.ui.components.NorthrootCard
import ca.northroot.app.ui.theme.*
import ca.northroot.app.utils.PlatformUtils

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun CustomersScreen(
    db: Db,
    isAdmin: Boolean,
    companyId: String,
    onBack: () -> Unit,
    onLogout: () -> Unit
) {
    var customers by remember { mutableStateOf<List<Customer>>(emptyList()) }
    var searchQuery by remember { mutableStateOf("") }

    LaunchedEffect(companyId) {
        db.getCustomers(companyId).collect { customers = it }
    }

    val filteredCustomers = remember(customers, searchQuery) {
        customers.filter { it.name.contains(searchQuery, true) || it.address.contains(searchQuery, true) }
    }

    Scaffold(
        topBar = {
            Column(Modifier.background(MaterialTheme.colorScheme.surface)) {
                TopAppBar(
                    title = { Text("Directory", fontWeight = FontWeight.Black) },
                    navigationIcon = { IconButton(onClick = onBack) { Icon(Icons.Default.ArrowBack, null) } },
                    actions = {
                        IconButton(onClick = onLogout) { Icon(Icons.Default.ExitToApp, null) }
                    }
                )
                OutlinedTextField(
                    value = searchQuery,
                    onValueChange = { searchQuery = it },
                    modifier = Modifier.fillMaxWidth().padding(16.dp),
                    placeholder = { Text("Search customers...") },
                    leadingIcon = { Icon(Icons.Default.Search, null) }
                )
            }
        },
        floatingActionButton = {
            if (isAdmin) {
                FloatingActionButton(onClick = { }, containerColor = MaterialTheme.colorScheme.primary) {
                    Icon(Icons.Default.PersonAdd, null, tint = MaterialTheme.colorScheme.onPrimary)
                }
            }
        }
    ) { padding ->
        Box(Modifier.padding(padding).fillMaxSize()) {
            if (filteredCustomers.isEmpty()) {
                Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                    Text("No customers found", color = Color.Gray)
                }
            } else {
                LazyColumn(Modifier.fillMaxSize(), contentPadding = PaddingValues(16.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    items(filteredCustomers) { customer ->
                        CustomerCard(customer = customer)
                    }
                }
            }
        }
    }
}

@Composable
fun CustomerCard(customer: Customer) {
    NorthrootCard(onClick = { }) {
        Row(Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(
                Modifier.size(44.dp).clip(CircleShape).background(MaterialTheme.colorScheme.primary.copy(alpha = 0.1f)),
                contentAlignment = Alignment.Center
            ) {
                Text(customer.name.take(1).uppercase(), fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary)
            }
            Spacer(Modifier.width(16.dp))
            Column(Modifier.weight(1f)) {
                Text(customer.name, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
                Text(customer.address, style = MaterialTheme.typography.bodySmall, color = Color.Gray)
            }
            IconButton(onClick = { PlatformUtils.launchDialer(customer.phone) }) {
                Icon(Icons.Default.Call, null, tint = MaterialTheme.colorScheme.primary)
            }
        }
    }
}
